import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: '2fr 4fr 3fr 3fr 5fr 4fr',
    padding: '8px 0 8px 12px',
    marginTop: 4,
    alignItems: 'center',
    borderRadius: 6,
    backgroundColor: theme.palette.background.paper,
    textAlign: 'center'
  }
}))
export default useStyles
